<template>
  <div class="statistics">
    <div
      v-if="loading"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      "
    >
      <Loading color="#217899" />
    </div>
    <v-data-table
      dense
      :headers="headers"
      :items="statistics"
      class="elevation-1"
      hide-default-footer
      disable-pagination
      v-else
    >
    </v-data-table>
  </div>
</template>
<script>
import Loading from "../../components/loading.vue";
export default {
  name: "statistics",
  components: { Loading },
  data: () => ({
    loading: false,
    headers: [
      {
        text: "Отправлено",
        value: "date",
        align: "center",
      },
      { text: "44-ФЗ", value: "fz44", align: "center" },
      { text: "615-ФЗ", value: "fz615", align: "center" },
      {
        text: "223-ФЗ",
        value: "fz223",
        align: "center",
      },

      { text: "Всего", value: "summary", align: "center" },
    ],
  }),

  computed: {
    statistics: {
      get() {
        return this.$store.getters.getStatistics;
      },
    },
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        await this.$store.dispatch("GET_STATISTICS");
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="sass" scoped></style>
